/*
 * @Author: 谭聪 156638174@qq.com
 * @Date: 2023-08-19 12:29:40
 * @LastEditors: 谭聪 156638174@qq.com
 * @LastEditTime: 2023-08-19 15:16:11
 * @FilePath: /mall-fe/src/views/Mobile/components/BrandZone.tsx
 * @Description: 渲染品牌区域内容
 *
 */

import ImageRenderer, { ResourcesFrom } from './ImageRenderer';
import { Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
const length = 6;

/**
 * @description: 用于将一个数组分成多个子数组，每个子数组的长度为指定的 sliceLength
 * @param {Array} cloth - 要分割的数组
 * @param {number} sliceLength - 每个子数组的长度
 * @returns {Array<Array>} - 分割后的子数组集合
 */
function cropp<T = any>(cloth: Array<T>, sliceLength: number): Array<Array<T>> {
  let statrtIndex = 0;
  let endIndex = sliceLength;
  const result: Array<Array<T>> = [];
  const { length } = cloth;
  while (statrtIndex < length) {
    result.push(cloth.slice(statrtIndex, endIndex));
    statrtIndex = endIndex;
    endIndex = statrtIndex + endIndex;
  }

  return result;
}

/**
 * @description: 品牌区域组件，用于渲染品牌区域内容
 * @param {object} props - 组件的属性对象
 * @param {Array<BrandEntity>} props.brandList - 品牌列表数组
 * @returns {JSX.Element} - 品牌区域组件的 JSX 元素
 */
function BrandZone(props: { brandList: Array<BrandEntity> }) {
  // 从 props 中获取品牌列表，默认为空数组
  const { brandList = [] } = props;

  // 调用 cropp 函数将品牌列表分组
  const groupBrand = cropp(brandList, length);

  return (
    <div className="brand-zone-main">
      <h2 className="product-title">第三方电商平台</h2>
      <Swiper
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        loop={true}
        modules={[Autoplay]}
      >
        {groupBrand.map((member, i) => (
          <SwiperSlide key={i}>
            {/* 循环渲染每个品牌 */}
            {member.map((brand) => (
              <div className="brand-content" key={brand.id}>
                <ImageRenderer
                  path={brand.image}
                  resourcesFrom={ResourcesFrom.publicCloud}
                  href={brand.link}
                />
              </div>
            ))}
          </SwiperSlide>
        ))}
        <style jsx global>
          {`
            .brand-zone-main {
              background: linear-gradient(180deg, #ebf4ff 0%, #ffffff 100%);
              border: 1px solid #ffffff;
              box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.1);
              border-radius: 6px;
              padding: 12px;
              margin-bottom: 12px;
            }
            .product-title {
              font-family: "FZZhengHeiS-DB-GB";
              font-style: normal;
              font-weight: bold;
              font-size: 16px;
              line-height: 20px;
              color: #24201d;
              margin: 0;
              margin-bottom: 12px;
            }
            .brand-content {
              height: 78px;
              width: 49%;
              background: #fff;
              border: 1px solid #e9eff4;
              margin-bottom: 2%;
            }
            .brand-content:nth-child(5n),
            .brand-content:nth-child(6n) {
              margin-bottom: 0;
            }

            .brand-content:nth-child(odd) {
              float: left;
            }
            .brand-content:nth-child(even) {
              float: right;
            }
          `}
        </style>
      </Swiper>
    </div>
  );
}

export default BrandZone;
